import React, { useState, useEffect } from "react";
import LibraryChapterProps from "./LibraryChapter/LibraryChapterProps";
import { useLocation } from "react-router-dom";
import axios from "../../../axios";
import { IP } from "../../../internalServer";
const LibrarySubjectSubDetail = ({ Subindex }) => {
  const { state } = useLocation();
  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId")
  );
  const [bookData, setBookData] = useState([]);
  const [openChapters, setOpenChapters] = useState(
    Array(bookData.length).fill(false)
  );
  const helper = (a) => {
    const str = a;
    const startsWithDot = str?.startsWith(".");
    if (startsWithDot) {
      let p = a.replace(/^\./, "");
      p = IP + p;
      return p;
    } else {
      return a;
    }
  };
  const handleToggleChapter = (index) => {
    const updatedOpenChapters = [...openChapters];
    updatedOpenChapters[index] = !updatedOpenChapters[index];
    setOpenChapters(updatedOpenChapters);
  };
  useEffect(() => {
    try {
      const handleBookData = async () => {
        let res = await axios.get(
          `/api/v1/cm/library/book/getBookByClassSectionSubject?standard_id=${state.standardId}&section_id=${state.sectionId}&subject_id=${state.subjectId}&timetableSessionId=${timeTableSessionId}`
        );
        setBookData(res.data.data[0].bookInfo);
      };
      handleBookData();
    } catch (error) {
      console.log(error);
    }
  }, []);
  return (
    <>
      {bookData.map((obj, index) => (
        <div className="total_container_book p-1 " key={index}>
          <div className="d-flex">
            <img
              // src={helper(obj.thumbnailImage)}
              src="/images/Book_XS.png"
              className="imageSize"
              alt="Book img"
            ></img>
            <div className="mt-3">
              <div className="book_title">
                Book {index + 1}: {obj.name}
              </div>
              <div className="chapters_Count mt-2">
                {obj.chapterData.length} Chapters &nbsp;
                <span
                  className="hide_chapter"
                  onClick={() => {
                    handleToggleChapter(index);
                    localStorage.setItem("SubIndex", JSON.stringify(Subindex));
                    localStorage.setItem(
                      "clickedChapter",
                      JSON.stringify(bookData[index])
                    );
                  }}
                >
                  {openChapters[index] ? "Hide Chapter" : "Show Chapter"}
                </span>
              </div>
            </div>
          </div>
          <div className="library_chapter_container">
            {openChapters[index] && (
              <LibraryChapterProps data={obj} subIndex={Subindex} />
            )}
          </div>
        </div>
      ))}
    </>
  );
};

export default LibrarySubjectSubDetail;
